export default __webpack_public_path__ + "static/media/Icon51.02f61633.svg";